<div
    *ngIf="isEditing"
    class="agpr-textInput"
    [class.agpr-textInput--spaced]="bottomMargin"
    [ngClass]="{'agpr-textInput--socialPlus' : style === agprComponentStyle.socialPlus}"
    [class]="styleClass"
    (focusout)="handleFocusOut($event)"
>
    <div class="agpr-textInput-container">
        <div class="agpr-textInput-inputWrapper">
            <div class="agpr-textInput-labelRow">
                <label
                    *ngIf="label || required"
                    [id]="id + '_label'"
                    [for]="id"
                    class="agpr-textInput-label"
                >
                    {{ label | localize }} <span *ngIf="required" class="agpr-textInput-required" aria-hidden="true">*</span>
                    <span
                        *ngIf="tooltip"
                        role="img"
                        class="fa-regular fa-circle-info agpr-textInput-tooltip"
                        [class.agpr-textInput-tooltip-large]="tooltipLarge"
                        [agprTooltip]="tooltip"
                        [tooltipPosition]="tooltipPosition"
                    ></span>
                </label>

                <div class="agpr-textInput-spacer"></div>
                <div
                    *ngIf="isUrl"
                    class="agpr-textInput-viewUrl"
                >
                <agpr-button
                    [id]="id + '_viewUrl'"
                    [style]="buttonTypes.icon"
                    [icon]="'fa-regular fa-arrow-up-right-from-square'"
                    agprTooltip="Core.viewUrl"
                    tooltipPosition="top"
                    (click)="viewUrl()"
                ></agpr-button>
                </div>
            </div>
            <div *ngIf="hint" [id]="id + '_hint'" class="agpr-textInput-hint">
                {{ hint | localize }}
            </div>
            <input
                [id]="id"
                #input
                [type]="type"
                [placeholder]="placeholder | localize"
                class="agpr-textInput-input"
                [ngClass]="ariaInvalid ? 'agpr-textInput-input-ariaInvalid' : null "
                [class.agpr-textInput-input--withIcon]="icon"
                [maxlength]="maxLength"
                [attr.autocomplete]="autocomplete"
                [attr.aria-label]="(ariaLabel ? ariaLabel : label) | localize"
                [disabled]="disabled"
                [(ngModel)]="value"
                (ngModelChange)="onModelChange(value)"
                (blur)="onBlur($event)"
                (focus)="onFocus($event)"
                (keydown)="onKeydown($event)"
                (keyup)="onKeyup($event)"
                [readOnly]="readonly"
                tabindex="0"
                [attr.required]="required ? true : null"
                [attr.aria-invalid]="ariaInvalid"
                [attr.aria-labelledby]="(ariaLabelledBy ? ariaLabelledBy : (label ? id + '_label' : '')) + (hint ? id + '_hint' : '')"
                [attr.aria-describedby]="ariaDescribedBy"
            />
            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
            <span
                *ngIf="icon && !iconPopoverTemplate && !iconDecorative"
                [attr.role]="iconClickable ? 'button' : 'img'"
                class="agpr-textInput-icon {{icon}}"
                [ngClass]="{
                    'agpr-textInput-icon-clickable': iconClickable,
                    'agpr-textInput-icon-clickable-disabled': !value
                }"
                [style.color]="iconColor"
                [attr.aria-disabled]="iconClickable && !value"
                [attr.aria-haspopup]="iconClickable ? ariaHasPopup : undefined"
                [agprTooltip]="iconClickable ? (value ? iconClickableTooltip : iconClickableDisabledTooltip) : iconTooltip"
                (click)="value && iconClickable ? iconClick.emit(event) : ''"
                (keyup.enter)="value && iconClickable ? iconClick.emit(event) : ''"
                (keyup.space)="value && iconClickable ? iconClick.emit(event) : ''"
            ></span>
            <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
            <span
                *ngIf="icon && iconPopoverTemplate && !iconDecorative"
                class="agpr-textInput-icon"
                [ngClass]="icon"
                role="img"
                [agprPopover]="iconPopoverTemplate"
                [popoverZIndex]="++zIndex"
                [popoverStyleClass]="iconPopoverStyleClass"
                [popoverText]="iconPopoverText"
            ></span>
            <span
                *ngIf="iconDecorative"
                class="agpr-textInput-icon agpr-textInput-icon--decorative"
                [ngClass]="icon"
                role="img"
                aria-hidden="true"
            ></span>
        </div>
    </div>
</div>
